export const flowConditionTabNames = {
  // -- TAB: About
  ABOUT: 'about',

  // -- TAB: Check
  CHECK_ON_START: 'ON_START',
  CHECK_IF_TRUE: 'IF_TRUE',
  CHECK_IF_FALSE: 'IF_TRUE'
}
